import { useState } from 'react';
import { UserCircle, Sparkles, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const DISMISSED_KEY = (uid) => `markerSync_profileBannerDismissed_${uid}`;

export default function ProfileBanner({ onSetUsername }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  const isDismissed = () => {
    if (typeof window === 'undefined' || !user) return true;
    return !!localStorage.getItem(DISMISSED_KEY(user.uid));
  };

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem(DISMISSED_KEY(user.uid), '1');
  };

  const handleCreate = () => {
    if (!user.username) {
      onSetUsername();
    } else {
      navigate(`/profile/${user.username}`);
    }
  };

  if (loading || !user || dismissed || isDismissed()) return null;

  return (
    <div className="bg-gradient-to-r from-amber-50 via-orange-50 to-amber-50 border-b border-amber-100">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <div className="p-1.5 bg-amber-100 rounded-lg shrink-0">
              <UserCircle size={18} className="text-amber-600" />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-medium text-slate-800">
                You can now create your public profile!
              </p>
              <p className="text-xs text-slate-600 hidden sm:block">
                Showcase all your published palettes in one place and share your socials.
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 shrink-0">
            <button
              onClick={handleCreate}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-amber-500 hover:bg-amber-600 text-white text-sm font-medium rounded-lg transition-colors"
            >
              <Sparkles size={14} />
              <span className="hidden sm:inline">Create profile</span>
              <span className="sm:hidden">Create</span>
            </button>
            <button
              onClick={handleDismiss}
              className="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
              title="Dismiss"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
